import * as React from 'react';
import { MapContext } from '../Map';
import useBindEvents from '../../hooks/useBindEvents';
import { IconFontType, iconStr, IconFontProps } from '../Icon';
import { Events } from '../../types';
// tslint:disable-next-line: no-var-requires
require('./assets/marker.less');

const {
  useContext, useEffect, useState, memo,
} = React;

export interface MarkerOptions {
  position: any; // AMap.LocationValue[] | AMap.LocationValue[][] | undefined;
  [option: string]: any;
}

export interface MarkerProps {
  markerOptions: MarkerOptions;
  hoverLabel?: AMap.Marker.Label;
  events?: Events;
  [option: string]: any;
}

function Marker(props: MarkerProps) {
  const { markerOptions, events } = props;

  const map = useContext(MapContext);
  const [marker, setMarker]: [any, any] = useState(null);

  useBindEvents(marker, events);

  useEffect(() => {
    if (!map) {
      return;
    }

    if (marker) {
      (map as unknown as AMap.Map).remove([marker]);
    }

    const { offset } = markerOptions;
    const markerOffset = offset ? new AMap.Pixel(offset[0], offset[1]) : new AMap.Pixel(-10, -34);

    const newMarker = new AMap.Marker({ ...markerOptions, offset: markerOffset });

    if (props.hoverLabel) {
      // 设置hover显示marker名称
      newMarker.on('mouseover', (e: any) => {
        newMarker.setLabel(props.hoverLabel);
        newMarker.setTop(true);
      });
      newMarker.on('mouseout', (e: any) => {
        newMarker.setLabel();
        newMarker.setTop(false);
      });
    }

    (map as unknown as AMap.Map).add(newMarker);

    setMarker(newMarker);

    return () => {
      if (newMarker) {
        (map as unknown as AMap.Map).remove([newMarker]);
      }
    };
  }, [map, markerOptions]);

  return null;
}

export default Marker;

export interface IconMarkerProps extends IconFontProps {
  position: any;
  type: IconFontType;
  hoverLabel?: AMap.Marker.Label;
  label?: any;
  labelCloseable?: boolean;
  labelVisible?: boolean;
  offset?: any;
  icon?: any;
  iconSize?: any;
  infoWindow?: any;
  zIndex?: any;
}

export function IconMarker(props: IconMarkerProps) {
  const {
    position, type, hoverLabel, ...iconFontProps
  } = props;
  return (
    <Marker
      markerOptions={{
        position,
        content: iconStr(type, iconFontProps),
      }}
      hoverLabel={hoverLabel}
    />
  );
}

export interface ImageMarkerProps extends MarkerProps {
  imageSrc?: string;
  innerText?: {
    text: string;
    color?: string;
    position?: 'mid' | 'top' | 'bottom' | 'left' | 'right';
    style?: string;
  };
  label?: {
    content: string;
    position?: 'mid' | 'top' | 'bottom' | 'left' | 'right';
    style?: string;
  };
}

const createImageContent = (innerText: ImageMarkerProps['innerText'], label: ImageMarkerProps['label'], imageSrc: string) => {
  const {
    text = null, color = '#fff', position: textPosition = 'mid', style: textStyle = '',
  } = innerText || {};
  const { content = null, position: labelPosition = 'mid', style: labelStyle = '' } = label || {};
  const positionMap = {
    mid: '',
    top: 'top: unset;bottom: 100%;transform: translate(-50%, -1px);',
    bottom: 'top:100%;transform:translate(-50%,-1px)',
    left: 'left: -1px;transform: translate(-100%, -50%);',
    right: 'left: 100%;transform: translate(-1px, -50%);',
  };
  const commonStyle = 'position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);';
  const span = text ? `<span style = "${commonStyle};color:${color};${positionMap[textPosition]};${textStyle};" >${text}</span>` : '';
  const subLabel = content ? `<div style = "${commonStyle};${positionMap[labelPosition]};${labelStyle}" >${content}</div>` : '';
  return `<div class='marker_img-box' style='position: relative;display: inline-block;'><img src="${imageSrc}" alt='' />${span}${subLabel}</div>`;
};

const contentInit: string | null = null;
export function ImageMarker(props: ImageMarkerProps) {
  const {
    imageSrc, markerOptions, hoverLabel, events, innerText, label,
  } = props;
  const [content, setContent] = useState(contentInit);
  useEffect(() => {
    setContent(() => (imageSrc ? createImageContent(innerText, label, imageSrc) : null));
  }, [imageSrc]);
  return (
    <Marker
      markerOptions={{
        ...markerOptions,
        content,
      }}
      hoverLabel={hoverLabel}
      events={events}
    />
  );
}


// -------------

export function CircleMarker(props: any) {
  const { events, data, circleMarkerOptions, fitAvoid, isAdd=true, isSetFitView=true } = props;
  const map = useContext(MapContext);
  const [marker, setMarker]: [any, any] = useState(null);

  useBindEvents(marker, events);

  useEffect(() => {
    if (!map) {
      return;
    }

    if (marker) {
      (map as unknown as AMap.Map).clearMap();
      (map as unknown as AMap.Map).remove([marker]);
    }

    const newMarkers = data && data.map((item: any) => {
      // return new AMap.CircleMarker({
      //   center: item,
      //   radius: 6, // 3D视图下，CircleMarker半径不要超过64px
      //   strokeColor: '#1A50F4',
      //   strokeWeight: 1,
      //   fillColor: '#C6D4FF',
      //   zIndex: 10,
      //   bubble: true,
      //   cursor: 'pointer',
      // });
      // console.log(item, 'item');
      if(item && Array.isArray(item)) {
        return new AMap.CircleMarker({...circleMarkerOptions, center: item});
      }else {
        return new AMap.CircleMarker(item);
      }
    });

    isAdd && (map as unknown as AMap.Map).add(newMarkers);

    setMarker(newMarkers);
    isSetFitView ? ((fitAvoid ? (map as unknown as AMap.Map).setFitView(newMarkers, false, fitAvoid) : (map as unknown as AMap.Map).setFitView())) : null;

    return () => {
      if (marker) {
        (map as unknown as AMap.Map).remove([marker]);
      }
    };
  }, [map, data, circleMarkerOptions]);

  return null;
}
